<template>
  <!-- :style="{
      background: backgroundImage,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }" -->
  <div class="group-members-layout">
    <div class="root-scrollbar content">
      <img v-if="currentMember.bgUrl" class="bg-image" :src="currentMember.bgUrl" alt="" />
      <!-- <img
        v-if="currentMember.rightUrl"
        class="right-image"
        :src="currentMember.rightUrl"
        :alt="currentMember.name || ''"
      />
      <div class="gm-introduce-root">
        <div class="gm-name">{{ currentMember.name }}</div>
        <div class="gm-sub">{{ currentMember.sub }}</div>
        <div class="gm-introduction" v-html="currentMember.introduction"></div>
      </div> -->

      <div v-if="GROUP_MEMBERS_LIST.length > 1" class="carousel-selector-layout">
        <div ref="CAROUSEL" class="carousel-images">
          <div
            v-for="(item, index) in GROUP_MEMBERS_LIST"
            :key="item.id || index"
            :style="{ transform: `translate(${translateX}px, 0)` }"
            :class="{ 'image-item-layout': true, 'image-item-activated': index === current }"
            @click="onLogoClick(index)"
          >
            <img class="image-item-image" :src="item.logoUrl" :alt="item.name || ''" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from '@/request/api/model'
const CATEGORY_ID = '1985184818377871362'

export default {
  data() {
    return {
      current: 0,
      translateX: 0,
      GROUP_MEMBERS_LIST: [],
      carousel_width: 0,
      language: localStorage.getItem('Language')
    }
  },
  computed: {
    currentMember() {
      return this.GROUP_MEMBERS_LIST[this.current] || {}
    }
  },
  created() {
    if (this.language === 'zh-CN') {
      this.getCNData()
    } else {
      this.getENData()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCarouselWidth)
  },
  methods: {
    async getCNData() {
      this.GROUP_MEMBERS_LIST = await this.getMembersData('0,1')
      this.resetCarousel()
    },
    async getENData() {
      this.GROUP_MEMBERS_LIST = await this.getMembersData('0,2')
      this.resetCarousel()
    },
    async getMembersData(contentType) {
      try {
        const res = await getData({
          categoryId: CATEGORY_ID,
          contentType,
          publishChannel: '0,1'
        })
        if (!res || res.code !== 0 || !Array.isArray(res.data)) {
          return []
        }

        return res.data.map((item) => {
          const fileList = Array.isArray(item.contentFileList) ? item.contentFileList : []
          return {
            id: item.id,
            name: item.contentTitle || '',
            sub: item.contentShortTitle || '',
            introduction: item.contentDescription || '',
            bgUrl: fileList[0] || '',
            logoUrl: fileList[1] || '',
            rightUrl: fileList[2] || ''
          }
        })
      } catch (error) {
        console.error(error)
        return []
      }
    },
    resetCarousel() {
      this.current = 0
      this.translateX = 0
      if (this.GROUP_MEMBERS_LIST.length > 1) {
        this.$nextTick(this.init)
      }
    },
    init() {
      this.updateCarouselWidth()
      window.removeEventListener('resize', this.updateCarouselWidth)
      window.addEventListener('resize', this.updateCarouselWidth)
    },
    updateCarouselWidth() {
      if (this.$refs.CAROUSEL) {
        this.carousel_width = this.$refs.CAROUSEL.clientWidth
      }
    },
    onClickArrow(index, pos = 1) {
      const baseX = 200
      const distanceX = baseX * pos
      const count = this.GROUP_MEMBERS_LIST.length
      const totalWidth = baseX * count

      // if (totalWidth < this.carousel_width) return

      const canTransWidth = totalWidth - this.carousel_width

      if (index === 1) {
        if (this.current === count - 1) return
        if (this.current < count) {
          this.current += pos
        }
        if (totalWidth < this.carousel_width) return
        if (this.current > count / 2) {
          const residue = canTransWidth - Math.abs(this.translateX)
          this.translateX -= residue > distanceX ? distanceX : residue
        }
      } else if (index === 0) {
        if (this.current > 0) {
          this.current -= pos
        }
        if (this.translateX === 0) return
        if (totalWidth < this.carousel_width) return
        if (this.current < count / 2 && this.translateX < 0) {
          this.translateX += Math.abs(this.translateX) > distanceX ? distanceX : Math.abs(this.translateX)
        }
      }
    },
    onLogoClick(index) {
      const pos = Math.abs(this.current - index)
      if (this.current > index) {
        this.onClickArrow(0, pos)
      } else if (this.current < index) {
        this.onClickArrow(1, pos)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style';
</style>
